export const onClientEntry = () => {
	// Add light mode favicon
	const lightFavicon = document.createElement("link");
	lightFavicon.rel = "icon";
	lightFavicon.href = "/jones-dev-light.ico";
	lightFavicon.media = "(prefers-color-scheme: light)";
	document.head.appendChild(lightFavicon);

	// Add dark mode favicon
	const darkFavicon = document.createElement("link");
	darkFavicon.rel = "icon";
	darkFavicon.href = "/jones-dev-dark.ico";
	darkFavicon.media = "(prefers-color-scheme: dark)";
	document.head.appendChild(darkFavicon);
};
